import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M8.75 4.75C8.75 3.64543 9.64543 2.75 10.75 2.75H19.25C20.3546 2.75 21.25 3.64543 21.25 4.75V13.25C21.25 14.3546 20.3546 15.25 19.25 15.25H10.75C9.64543 15.25 8.75 14.3546 8.75 13.25V4.75Z",
      stroke: "var(--icon-color, #28373c)",
      "stroke-width": "var(--icon-stroke-width, 1.5)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12.25 8.75H13.25C14.3546 8.75 15.25 9.64543 15.25 10.75V11.75",
      stroke: "var(--icon-color, #28373c)",
      "stroke-width": "var(--icon-stroke-width, 1.5)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M8.75 8.75H4.75C3.64543 8.75 2.75 9.64543 2.75 10.75V19.25C2.75 20.3546 3.64543 21.25 4.75 21.25H13.25C14.3546 21.25 15.25 20.3546 15.25 19.25V15.25",
      stroke: "var(--icon-color, #28373c)",
      "stroke-width": "var(--icon-stroke-width, 1.5)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }